import utils from 'utils'
import receiveTicketTemplate from './views/receiveTicketTemplate.html'
import updatesModalTemplate from './views/updatesModalTemplate.html'
class InventoryQueryCtrl {
    constructor($scope, httpRequest, $q, logger, $http, querySort, initSortService, IQfieldConfig, composeService, $uibModal, dictService) {
        // 列表查询字段设置
        $scope.customizedConfig = IQfieldConfig
        $scope.selectedList = []
        $scope.dictData = {}
        // 开票点数据
        const getUkeyList = () => {
            let ukeyList = JSON.parse(localStorage.user_info).sysUkeyList
            ukeyList.forEach((el) => {
                el.enumCode = el.ukeyCode
                el.enumName = el.ukeyName
            })
            $scope.dictData.ukeyList = ukeyList
        }
        $scope.queryParam = {
            pageSize: 10,
            pageNum: 1,
            param: {
                diskType: '',
                invoiceType: '51',
                manageType: '',
                orgName: '',
                taxCode: '',
                ukeyCode: '',
            },
        }
        const dictArr = ['ovat_disk_type', 'manage_type', 'inv_type']
        const getDict = () => {
            dictService.getAndCache(dictArr).then((res) => {
                Object.assign($scope.dictData, res)
                $scope.dictData['inv_type'] = $scope.dictData['inv_type'].filter((el) => {
                    return el.enumCode == 51
                })
                $scope.dictData['manage_type'] = $scope.dictData['manage_type'].filter((el) => {
                    return el.enumCode == 1 || el.enumCode == 2 || el.enumCode == 3
                })
                $scope.dictData['ovat_disk_type'] = $scope.dictData['ovat_disk_type'].filter((el) => {
                    return el.enumCode != 1
                })
                console.log($scope.dictData)
            })
        }
        /**
         * @description: 删除只出现一次的数据
         * @param {*} obj
         */
        const deleteANumData = (obj) => {
            obj.UkeyList.forEach((item) => {
                // 出现次数
                let num = 0
                obj.OriginalUkeyList.forEach((el) => {
                    if (el.taxCode === item.taxCode) {
                        num += 1
                    }
                })
                if (num === 1) {
                    let ind = obj.OriginalUkeyList.findIndex((o) => {
                        return o.taxCode === item.taxCode
                    })
                    obj.OriginalUkeyList.splice(ind, 1)
                }
            })
            return obj
        }
        /**
         * @description: 第一条数据true 其余默认false
         * @param {*} obj
         */
        const firstDataDefault = (obj) => {
            obj.OriginalUkeyList.forEach((item) => {
                let num = 0
                obj.listData.forEach((el) => {
                    if (el.taxCode === item.taxCode) {
                        num += 1
                        // 相同税号只默认第一条数据true 其余false
                        if (num > 1) {
                            el.buyTickets = false
                        }
                    }
                })
            })
            return obj
        }
        const listComposeService = composeService(firstDataDefault, deleteANumData)
        /**
         * @description: 默认购票true
         * @param {*} listData
         */
        const setBtnDefaultTrue = (listData) => {
            listData.forEach((el) => {
                el.buyTickets = true
            })
            return listData
        }
        /**
         * @description: 相同税号只默认第一条数据true 其余false
         * @param {*} listData
         */
        const setTicketsBtnFalse = (listData) => {
            let UkeyList = listData.filter((el) => el.diskType == 3)
            let OriginalUkeyList = JSON.parse(JSON.stringify(UkeyList))
            const obj = listComposeService({ UkeyList, OriginalUkeyList, listData })
            return obj.listData
        }
        $scope.dataComposeService = composeService(setTicketsBtnFalse, setBtnDefaultTrue)
        const queryInventory = function queryInventory() {
            httpRequest.post_queryDeviceStockBelle($scope.queryParam).then((res) => {
                // $scope.listData = $scope.dataComposeService(res.data.value.list)// 由后端处理显示一条数据
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
                $scope.queryParam.pageSize = res.data.value.pageSize
                $scope.selectedList = []
            })
        }
        const belleRegionList = () => {
            // 百丽--获取地区时两个参数都不传，获取管理城市时两个都要传--百丽接口
            httpRequest.get_getBelleRegion().then((res) => {
                $scope.belleRegionList = res.data.value
            })
        }
        const taxBureauList = () => {
            // 主管税局省（市）
            httpRequest.get_getAllTaxBureau(localStorage.getItem('id_token')).then((res) => {
                $scope.dictDataProvince = res.data.value
            })
        }

        $scope.queryInventory = queryInventory
        $scope.init = composeService(taxBureauList, belleRegionList, getDict, getUkeyList)
        $scope.init()
        $scope.searchList = () => {
            queryInventory()
        }
        $scope.reset = () => {
            $scope.queryParam = {
                pageSize: 10,
                pageNum: 1,
                param: {
                    diskType: '',
                    invoiceType: '51',
                    manageType: '',
                    orgName: '',
                    taxCode: '',
                    ukeyCode: '',
                },
            }
        }
        $scope.tableDropdownConfig = [
            {
                label: '购票',
                handler(item) {
                    const { taxCode } = item
                    let params = [
                        {
                            approvedType: getApprovedType(item),
                            taxNo: taxCode,
                        },
                    ]
                    confirmBuyTickets({ params, tips: this.label })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('stoct_ticket_purchase') && receivAndPurchasPermit(item)
                },
            },
            {
                label: '领票',
                handler(item) {
                    const { diskId, diskType, taxCode, applyRecordId } = item
                    let params = [
                        {
                            diskId,
                            diskType,
                            applyRecordId,
                            invoiceSourceQuery: {
                                taxNo: taxCode,
                            },
                            receiveInvNumber: '',
                            taxNo: taxCode,
                        },
                    ]
                    confirmInvReceive({ params, tips: this.label })
                },
                showWhile(item, hasPermit) {
                    return hasPermit('stock_ticket_collection') && receivAndPurchasPermit(item) && item.applyRecordId
                },
            },
        ]
        function receivAndPurchasPermit(item) {
            const { manageType, diskType, ukeyCode } = item
            if (!Object.is(manageType, '3')) return false
            const diskTypeMapper = {
                //航信金税盘
                2: {
                    mapper() {
                        if (Object.is(ukeyCode, '0')) return true
                        return false
                    },
                },
                // 新税控-UKey
                3: {
                    mapper() {
                        return true
                    },
                },
                // 百望税控盘
                4: {
                    mapper() {
                        if (Object.is(ukeyCode, '0')) return true
                        return false
                    },
                },
            }

            return diskTypeMapper[diskType].mapper()
        }
        /**
         * @description: 批量购票
         */
        $scope.batchBuyTicket = () => {
            $scope.batchTips = '批量购票'
            if (!batchBuyTicketCheck()) return
            confirmBuyTickets({ params: $scope.buyTicketParamList, tips: $scope.batchTips })
        }
        /**
         * @description: 批量领票
         */
        $scope.batchReceiveTicket = () => {
            $scope.batchTips = '批量领票'
            if (!batchReceiveTicketCheck()) return
        }
        const isSelectData = (x) => {
            if (!$scope.selectedList.length) {
                logger.logError(`请选择要${$scope.batchTips}的数据！`)
                return false
            }
            return true
        }
        const onlyChooseTenData = (x) => {
            if (!x) return false
            if ($scope.selectedList.length > 10) {
                logger.logError(`批量购票支持选择10家公司`)
                return false
            }
            return true
        }
        const buyTicketParamHandel = (x) => {
            if (!x) return false
            $scope.buyTicketParamList = $scope.selectedList.map((el) => {
                return {
                    approvedType: getApprovedType(el),
                    taxNo: el.taxCode,
                }
            })
            return true
        }
        const showModalPage = (x) => {
            if (!x) return false
            $uibModal
                .open({
                    template: receiveTicketTemplate,
                    controller: 'receiveTicketModal',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-hg',
                    resolve: {
                        items1() {
                            return { list: $scope.selectedList, dictData: $scope.dictData }
                        },
                    },
                })
                .result.then(
                    (params) => {
                        confirmInvReceive({ params, tips: '批量领票' })
                    },
                    () => {}
                )
        }
        const ukeyCodeZeroCheck = (x) => {
            if (!x) return false
            let hasNonZero = $scope.selectedList.every((el) => el.ukeyCode == 0)
            if (!hasNonZero) {
                logger.logError(`存在开票点编号不为0的数据，请检查！`)
                return false
            }
            return true
        }
        const isA10Check = (x) => {
            if (!x) return false
            let isA10 = $scope.selectedList.every((el) => el.manageType == 3)
            if (!isA10) {
                logger.logError(`存在开票方式不为新税控服务器A10的数据，请检查！`)
                return false
            }
            return true
        }
        const isGoldPlateukeyCode0 = (x) => {
            if (!x) return false
            const goldPlateList = $scope.selectedList.filter((el) => el.diskType == '2')
            let isUkeyCode0 = goldPlateList.every((el) => el.ukeyCode == '0')
            if (!isUkeyCode0) {
                logger.logError(`存在航信金税盘开票点不为0的数据，请检查！`)
                return false
            }
            return true
        }
        const isApplySuccess = (x) => {
            if (!x) return false
            let isApply = $scope.selectedList.some((el) => el.applyRecordId == null)
            if (isApply) {
                logger.logError(`存在未购票的数据，请检查！`)
                return false
            }
            return true
        }
        const isServerHosting = (x) => {
            if (!x) return false
            let isServer = $scope.selectedList.some((el) => el.manageType == 2)
            if (isServer) {
                logger.logError(`服务器托管开票方式不能批量购票和批量领票，请检查！`)
                return false
            }
            return true
        }
        const RPPermitComposeService = composeService(isGoldPlateukeyCode0, isA10Check)
        function confirmBuyTickets(obj) {
            const { params, tips } = obj
            httpRequest.post_invoiceAutoApply(params).then((res) => {
                logger.logSuccess(tips)
                queryInventory()
            })
        }
        function confirmInvReceive(obj) {
            const { params, tips } = obj
            httpRequest.post_invoiceAutoReceive(params).then((res) => {
                logger.logSuccess(tips)
                queryInventory()
            })
        }
        /**
         * @description: //核定类型：UKey 传0 金税盘：纸质专票、纸质普票  传0  其他 (机动车；卷式票；电子普票；二手车；电子专票)  传1
         */
        function getApprovedType(item) {
            const { diskType, invoiceType } = item
            const diskTypeMap = {
                2: {
                    mapper() {
                        return 0
                    },
                    name: '航信金税盘',
                },
                3: {
                    mapper() {
                        //纸质专用发票 0 纸质普通发票 2
                        if (invoiceType == 0 || invoiceType == 2) {
                            return 0
                        } else {
                            return 1
                        }
                    },
                    name: '新税控-UKey',
                },
                4: {
                    mapper() {
                        return null
                    },
                    name: '百望税控盘',
                },
            }

            return diskTypeMap[diskType].mapper()
        }
        /**
         * @description: 批量购票数据校验
         */
        const batchBuyTicketCheck = composeService(buyTicketParamHandel, RPPermitComposeService, onlyChooseTenData, isSelectData)
        /**
         * @description: 批量领票数据校验
         */
        const batchReceiveTicketCheck = composeService(showModalPage, isApplySuccess, RPPermitComposeService, isSelectData)
        /**
         * @description: 单个购票数据校验
         */
        const singleBuyTicketsCheck = composeService(isSelectData)
        // 导出
        $scope.exportExcel = function exportExcel() {
            const reqObj = $.extend({}, $scope.queryParam.param)
            let _url = `${host.etcloudBiApp}stock/biInvStockApply/exportInvoiceStockToXLS?accessToken=${localStorage.getItem('id_token')}`
            utils.post_downLoad(reqObj, _url)
        }
        // 状态更新
        $scope.statusUpdates = () => {
            $scope.batchTips = '状态更新'
            if (!statusUpdatesCheck($scope.selectedList)) return
        }
        const updatesModal = (x) => {
            if (!x) return false
            $uibModal
                .open({
                    template: updatesModalTemplate,
                    controller: 'statusUpdatesModal',
                    backdrop: 'static',
                    openedClass: 'mod-modal mod-modal-md',
                    resolve: {
                        items1() {
                            return $scope.selectedList
                        },
                    },
                })
                .result.then(
                    (updatesDataParam) => {
                        httpRequest.post_batchUpdateApplyState(updatesDataParam).then((res) => {
                            logger.logSuccess(`批量更新成功！`)
                            queryInventory()
                        })
                    },
                    () => {}
                )
            return true
        }
        const statusUpdatesCheck = composeService(updatesModal, isSelectData)
    }
}

InventoryQueryCtrl.$inject = ['$scope', 'httpRequest', '$q', 'logger', '$http', 'querySort', 'initSortService', 'IQfieldConfig', 'composeService', '$uibModal', 'dictService']
export default InventoryQueryCtrl



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/InventoryQuery/InventoryQueryCtrl.js